var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "after-pay-root", style: _vm.cssVars() }, [
    _c(
      "div",
      { staticClass: "after-pay-con" },
      [
        _c("div", [
          _vm.pkgName
            ? _c("img", {
                attrs: { src: _vm.getMatchImg("app-logo", _vm.pkgName) },
              })
            : _vm._e(),
        ]),
        _c("MyPLabel", {
          staticClass: "page-tips",
          attrs: {
            str: _vm.$t("lang.commonM.k348"),
            numsOption: [{ value: _vm.pkgName }],
          },
        }),
        _c("button", { on: { click: _vm.handleToApp } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/common/arrow10.png"),
            },
          }),
        ]),
        _c("p", { staticClass: "btn-tips" }, [
          _vm._v(_vm._s(_vm.$t("lang.commonM.k349"))),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }